<template>
  <div>
    <section class="content_section">
      <div v-if="options.showCollectionSettings" style="display: flex; justify-content: space-between; align-items: center; padding-right: 2rem;">
        <h1 style="padding-left: 20px;">{{ options.Lang.Collections }}</h1>
        
        <div style="display: flex; margin-left: 1.5rem; width: calc(40% - 3rem); align-items: center;">
          <md-icon v-if="suche == ''">search</md-icon>
          <div class="hoverSearch" @click="resetSearch()">
            <md-icon v-if="suche != ''" >close</md-icon>
          </div>
          <div style="flex: 1; display: flex; align-items: center;">
            <md-field style="margin-right: 20px; margin-top: -0.5rem !important; width: 80%;" class="md-focused">
              <md-input tabindex="4" name="bezeichnung" :placeholder="options.Lang.Suche" @input="checkSaveButton" id="bezeichnung" v-model="suche" />
            </md-field>
          </div>
          <md-button class="md-raised md-primary" @click="editBrand('neu')">{{ options.Lang.neueCollection }}</md-button>
        </div>
      </div>

    <form class="p-20" v-if="renderComp && options.showCollectionSettings" >
      <md-field v-if="!searching" v-for="(brand, index) in brands" :key="index" class="modul">
      <div clasS="groupContainer" @click="showPreViewContent(brand)"> 
        <div class="groupContentContainer">
          <p>
            <span>
              <md-icon>playlist_add_check_circle</md-icon>
            </span>
            {{ brand.name }}
          </p>
          <div class="iconHandler">
            <md-button @click="deleteBrand(brand.id)"><md-icon class="icon" >delete</md-icon></md-button>
            <md-button @click="editBrand(brand)"><md-icon class="icon" >edit</md-icon>  </md-button>
          </div>
        </div>
      </div>
      <div class="preView" v-if="brand?.isOpen">
        <div v-if="brand.collection != null && brand.collection != 'null'" class="preViewHeadline">
          <span>Branding</span>
          <span>Name</span>
          <span>Trip-ID</span>
          <span>Trip {{ options.Lang.Bezeichnung }}</span>
        </div>
        <div v-else>{{ options.Lang.noEntries }}</div>
        <div class="preViewContent" v-for="(trip, index) in groupTrips" :key="trip+index">
          <span v-if="trip?.brandingName">{{ trip?.brandingName }}</span>
          <span v-if="!trip.brandingName"></span>
          <span>{{ trip?.firstName }} {{ trip?.lastName }}</span>
          <span class="preViewTrip" @click="preViewTrip(trip?.tripID)">{{ trip?.tripID }}</span>
          <span>{{ trip?.tripDescription }}</span>
        </div>
      </div>
      </md-field>
     

      <md-field v-if="searching" v-for="(brand, index) in searchBrands" :key="index" class="modul">
        <div clasS="groupContainer" @click="showPreViewContent(brand)"> 
          <div class="groupContentContainer">
            <p>
              <span>
                <md-icon>playlist_add_check_circle</md-icon>
              </span>
              {{ brand.name }}
            </p>
            <div class="iconHandler">
              <md-button @click="deleteBrand(brand.id)"><md-icon class="icon" >delete</md-icon></md-button>
              <md-button @click="editBrand(brand)"><md-icon class="icon" >edit</md-icon>  </md-button>
            </div>
          </div>
        </div>
        <div class="preView" v-if="brand?.isOpen">
          <div v-if="brand.collection != null && brand.collection != 'null'" class="preViewHeadline">
            <span>Branding</span>
            <span>Name</span>
            <span>Trip-ID</span>
            <span>Trip {{ options.Lang.Bezeichnung }}</span>
          </div>
          <div v-else>{{ options.Lang.noEntries }}</div>
          <div class="preViewContent" v-for="(trip, index) in groupTrips" :key="trip+index">
            <span v-if="trip?.brandingName">{{ trip?.brandingName }}</span>
            <span v-if="!trip.brandingName"></span>
            <span>{{ trip?.firstName }} {{ trip?.lastName }}</span>
            <span class="preViewTrip" @click="preViewTrip(trip?.tripID)">{{ trip?.tripID }}</span>
            <span>{{ trip?.tripDescription }}</span>
          </div>
        </div>  
      </md-field>
      
    </form>
    
    <Success :options="options"></Success>
    </section>

    <Collection v-if="options.showCollectionForm"
    :options="options" 
    :id="this.brandId" 
    :bezeichnung="this.brandBez" 
    :collection="this.BrandCol"></Collection>
    
    <DeleteModal v-if="showDeleteModal" 
    :boolean-prop="showDeleteModal" 
    :id="brandId"
    @update-boolean="updateshowDeleteModal"
    @active-delete="deleteGroup"
    :options="options"></DeleteModal>
  </div>
 

</template>

<script>
import * as moment from 'moment'
import Success from '../../components/dialogs/Success.vue'
import Collection from '../../components/dialogs/editCollection.vue'
import DeleteModal from '../../components/dialogs/DeleteModal.vue'



export default {
  name: 'settings',
  components: {
    Success, 
    Collection,
    DeleteModal
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searching: false,
      suche: "",
      renderComp: false,
      searchBrands: [],
      brands: [],
      brandId: null,
      brandBez: null,
      BrandCol: null,
      showPreView: false,
      newCollections :[],
      suppliers: [],
      existingTrip: [],
      groupTrips: [],
      showDeleteModal: false,
      brandings: [],
      trips: []
    }
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  async created() {
    await this.getAllSuppliers();
    await this.getAllBrandings();
    await this.getModules();
    
  
  },
  async mounted() {
    this.options.showCollectionSettings = true,
    this.options.showCollectionForm = false,
    await this.getAllSuppliers(),
    await this.getAllBrandings()
  },

  methods: {
    async getAllSuppliers() {
      let self = this;
      await this.doPost({user: self.options.user}, 'getTripsForCollection', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          await self.responseToTableData(res.data.data, self.cols).then(values => {
            self.suppliers = values;
          })
          
          if (self.suppliers.length > 0) {
           
            let uebergabe = [];

if (self?.options?.user?.brandings.length > 0) {
  self.suppliers.forEach(sup => {
        if (self?.options?.user?.brandings.includes(sup.branding_id) && sup.branding_id != null) {
            uebergabe.push(sup);
        }
    });
}

self.suppliers = uebergabe;            
          }
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },

    
async getAllBrandings() {
      this.brandings = [];
      let self = this;
      await self.doPost({}, 'getAllBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;  
          for(let i = 0; i < result.length; i++){
            self.brandings.push(result[i])
          }
        }
      });    
    },

      resetSearch(){
        this.suche = ""
        this.checkSaveButton()
      },

      checkSaveButton(){
        if(this.suche != ""){
          this.searching = true
          this.getSearching()
        }else{
          this.searching = false
        }
      },

      getSearching(){
        this.searchBrands = [];
        if(this.brands.length > 0){
          this.brands.forEach((brand) =>{
            if(brand?.collection == null) {
              if(brand.name.toLowerCase().includes(this.suche.toLowerCase())) {
                if(!this.searchBrands.some(b => b.name === brand.name)) {
                  this.searchBrands.push(brand)
                }
              }

            } else {
              let collection = JSON.parse(brand.collection);
              collection.forEach(col => {
                let trip = this.suppliers.find((exist) => exist.trip_id == col.id);
                let fullName = "NO"
                if(this.searchFilter(brand, col, fullName)){
                  if (!this.searchBrands.some(b => b.name === brand.name)) {
                    this.searchBrands.push(brand);
                  }
                }
              })
            }
          })
        }
      },

      searchFilter(brand, col, fullName) {
        return brand.name.toLowerCase().includes(this.suche.toLowerCase()) || col.toLowerCase().includes(this.suche.toLowerCase()) || fullName.toLowerCase().includes(this.suche.toLowerCase())
      },

      async deleteBrand(id) {
      let self = this;
      this.brandId = id;
      this.showDeleteModal = true;
    },

    updateshowDeleteModal(newBoolean) {
      this.showDeleteModal = newBoolean
    },

    async deleteGroup(id, newBoolean) {
      this.showDeleteModal = newBoolean;
      let self = this;
      let updateData = {
        id: id,
      }
      await this.doPost({ data: updateData }, 'deleteCollection', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          window.setTimeout(self.abort(), 1500);
        }
      });
      await self.resetpdfs();
    },

    abort() {
      window.setTimeout(function(){location.reload();}, 1000)
    },

    editBrand(id){
      this.options.showCollectionSettings = false
      if(id == "neu"){
        this.brandId = null;
      }else{
        this.brandId = id.id;
        this.brandBez = id.name;
        this.BrandCol = id.collection
      }
      this.options.showCollectionForm = true;
    },

    getModules() {
      this.renderComp = false;
      let self = this;
      self.brands = [];
      self.doPost({ data: self.options.user }, 'getAllCollections', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          result = result.sort((a, b) => b.id - a.id);
          if (result?.length > 0) {
            // add isOpen = false to every item
            result = result.map(r => ({ ...r, isOpen: false }));
            self.brands = result;
          }
        }
        self.renderComp = true;
      });
    },

    showPreViewContent(brand) {
      this.brands.forEach((brand) => {
        if(brand.isOpen) {
          brand.isOpen = false
        }
      })
      brand.isOpen = !brand.isOpen
      this.getBrandInformations(brand)
    },

    getBrandInformations(brand) {
      this.existingTrip = [];
      this.groupTrips = [];

      // Add proper validation before parsing
      if (brand?.collection !== null &&
          brand?.collection !== "<null>" &&
          brand?.collection !== "null" &&
          brand?.collection) {
        try {
          let collection = JSON.parse(brand.collection);
          collection.forEach(element => {
            let trip = this.suppliers.find((exist) => exist.trip_id == element.id);
            if (trip) {
              trip.bezeichnungNeu = element.bezeichnung;
              this.existingTrip.push(trip);
            }
          });
          this.getNameInformations();
        } catch (error) {
          console.warn('Invalid JSON in brand.collection:', brand.collection);
        }
      }
    },
    
    getNameInformations() {
      this.groupTrips = [];
      this.existingTrip.forEach((element) => {
        let tripId = element?.trip_id;
        let firstName = element.firstname;
        let lastName = element.lastname;
        let description = element?.bezeichnungNeu;
        let brandingID = element?.branding_id;
        let newExistingTrip = {
          tripID: tripId,
          firstName: firstName,
          lastName: lastName,
          tripDescription: description,
          brandingID: brandingID
        }
        this.groupTrips.push(newExistingTrip);
      })
      this.checkBranding();
    },

    checkBranding() {
      this.groupTrips.forEach(trip => {
        this.brandings.forEach(branding => {
          if(trip?.brandingID == branding?.id) {
            trip.brandingName = branding.bezeichnung;
            trip.brandingLogo = branding.baseLogo
          }
        })
      })
    },

    preViewTrip(id) {
      window.open(process.env.VUE_APP_CLIENT_URL + "/angebot?trip=" + id + "&token=" + this.options.user.token, "_blank");
    },

    async resetpdfs(){
      let data = {
			  tripId : "allall"
		}
      let self = this;
      await self.doPost({data: data}, 'setStatusPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        self.pdfReset = false;
      }
    });
    },


  }
};
</script>
<style scoped lang="scss">
.hoverSearch:hover{
  cursor: pointer;
}

.iconHandler{
  margin-right: 5rem !important;
  width: 5rem;
  align-content: center;
  display: flex;
  justify-content: space-between;
}

.icon:hover{
  cursor: pointer;
}
.modul{
  width: 100%;
  background-color: white;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 1rem !important;
  height: auto;
}

.modul:hover{
  background-color: rgb(240, 240, 240);
}

.modul p {
  font-size: 18px;
  font-weight: 100;
  align-self: center;
  margin: 0;
}
h1 {
  font-size: 32px;
}

.groupContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;

  .groupContentContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  
}
.preView {
      background-color: lightgrey;
      width: 100%;
      position: relative;
      top: 16px;
      display: flex;
      flex-direction: column;
      border-bottom-right-radius: 1rem;
      border-bottom-left-radius: 1rem;
      margin-bottom: 1rem;

      .preViewHeadline {
        font-weight: bold;
        text-transform: uppercase;
      }

      div {
        display: flex;
        flex-direction: row;
        padding: 10px 3rem 10px 3rem;
        justify-content: space-between;
        width: 100%;

        span {
          width: 25%;
        }
      }
}

.preViewTrip {
  cursor: pointer;

  &:hover {
    color: darkblue;
    font-weight: bold;
  }
}

.md-field {
  padding-top: unset;
}




@media only screen and (max-width: 1500px) {
 
}

@media only screen and (max-width: 1240px) {


}

@media only screen and (max-width: 1140px) {
 
}</style>